import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useTheme } from "@mui/material/styles";
import { Box, List, Typography, useMediaQuery } from "@mui/material";
import NavItem from "./NavItem";
import { dispatch, useSelector } from "store";
import { activeID } from "store/reducers/menu";

const NavGroup = ({ item, lastItem, remItems, lastItemId, open, selectedItems, setSelectedItems,handleDrawerToggle  }) => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const { drawerOpen } = useSelector((state) => state.menu);
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentItem, setCurrentItem] = useState(item);
  const openMini = Boolean(anchorEl);

  useEffect(() => {
    if (lastItem) {
      if (item.id === lastItemId) {
        const localItem = { ...item };
        const elements = remItems.map((ele) => ele.elements);
        localItem.children = elements.flat(1);
        setCurrentItem(localItem);
      } else {
        setCurrentItem(item);
      }
    }
  }, [item, lastItem, downLG]);

  const checkOpenForParent = (child, id) => {
    child &&
      child.length !== 0 &&
      child.forEach((ele) => {
        if (ele && ele?.children && ele.children?.length !== 0) {
          checkOpenForParent(ele.children, currentItem.id);
        }
        if (ele && ele.url === pathname) {
          dispatch(activeID(id));
        }
      });
  };
  const checkSelectedOnload = (data) => {
    const childrens = data.children ? data.children : [];
    childrens &&
      childrens.length !== 0 &&
      childrens.forEach((itemCheck) => {
        if (itemCheck && itemCheck?.children && itemCheck.children?.length) {
          checkOpenForParent(itemCheck && itemCheck.children, currentItem.id);
        }
        if (itemCheck && itemCheck.url === pathname) {
          dispatch(activeID(currentItem.id));
        }
      });
  };

  useEffect(() => {
    checkSelectedOnload(currentItem);
    if (openMini) setAnchorEl(null);
  }, [pathname, currentItem]);

  const navCollapse = currentItem.children?.map((menuItem) => {
    switch (menuItem && menuItem.type) {
      case "collapse":
        return (
          <Typography
            key={menuItem && menuItem.id}
            variant="h6"
            color="error"
            align="center"
          >
            Pro Version
          </Typography>
        );
      case "item":
        return (
          <NavItem
            key={menuItem && menuItem.id}
            item={menuItem}
            level={1}
            open={open}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
          />
        );
      default:
        return (
          <Typography
            key={menuItem && menuItem.id}
            variant="h6"
            color="error"
            align="center"
          >
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <>
      <List
        subheader={
          item.title &&
          open && (
            <Box sx={{ pl: 2.2, mb: 1 }}>
              <Typography
                variant="h5"
                sx={{ color: "#a58b00", textTransform: "uppercase", fontSize: "0.6rem", letterSpacing: "0.08em", fontWeight: 700 }}
              >
                {item.title}
              </Typography>
              {item.caption && (
                <Typography variant="caption" sx={{ color: "#888" }}>
                  {item.caption}
                </Typography>
              )}
            </Box>
          )
        }
        sx={{ mt: open && item.title ? 1.5 : 0, py: 0, zIndex: 0 }}
      >
        {navCollapse}
      </List>
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object,
  lastItem: PropTypes.bool,
  remItems: PropTypes.array,
  lastItemId: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
  caption: PropTypes.string,
  open: PropTypes.bool,
  selectedItems: PropTypes.string,
  setSelectedItems: PropTypes.func,
};

export default NavGroup;
